import React from 'react';
import { Link } from 'react-router-dom';

const HeaderMiddle = ({ loggedUser, productsCount, onSettingsMenuClick, settingsMenuVisibility, toggleSettingsMenu }) => {

  const renderAccountMenu = () => {
    if (loggedUser) {
      const userName = loggedUser.name ? `Hi ${loggedUser.name.first}` : 'Account';
      return (
        <div className="account-menu">
          <button className="account-trigger" onClick={() => toggleSettingsMenu ? toggleSettingsMenu() : null}>
            <span className="account-icon" aria-hidden="true">
              <i className="fa fa-user" />
            </span>
            <span className="account-label">{userName}</span>
            <i className="fa fa-caret-down account-caret" aria-hidden="true"></i>
          </button>
          {settingsMenuVisibility ? (
            <ul className="account-dropdown">
              <li>
                <Link to="/settings?edit=profile">Profile</Link>
              </li>
              <li>
                <Link to="/settings?edit=orders" onClick={() => onSettingsMenuClick ? onSettingsMenuClick('orders') : null}>Orders</Link>
              </li>
              <li>
                <Link to="/settings?edit=payment-methods" onClick={() => onSettingsMenuClick ? onSettingsMenuClick('payment-methods') : null}>Payment Methods</Link>
              </li>
              <li>
                <Link to="/" onClick={() => onSettingsMenuClick ? onSettingsMenuClick('logout') : null}>Logout</Link>
              </li>
            </ul>
          ) : null}
        </div>
      )
    }

    return (
      <Link to="/signin" className="nav-link sign-in-link">
        <span className="account-icon" aria-hidden="true">
          <i className="fa fa-user" />
        </span>
        <span className="account-label">Sign In</span>
      </Link>
    )
  }

  return (
    <div className="main-nav-bar">
      <div className="nav-container">
        <Link to="/" className="logo-wordmark">
          <span className="logo-primary">JASON'S</span>
          <span className="logo-subtitle">WINE & SPIRITS</span>
        </Link>
        <div className="nav-actions">
          <Link to="/products?department=WINES"  className="order-now-btn">Order Now</Link>
          {renderAccountMenu()}
          <Link to="/cart" className="cart-button" aria-label="Shopping cart">
            <i className="fa fa-shopping-bag" />
            {productsCount ? (
              <span className="count-indicator">{productsCount}</span>
            ) : null}
          </Link>
        </div>
      </div>
    </div>
  )
}

export default HeaderMiddle;



// WEBPACK FOOTER //
// ./src/components/commons/header/HeaderMiddle.js